export const TERMS_AND_CONDITIONS_URL =
  "https://super-real-talenttcs.carrd.co/";
